<div class="preclinical flex flex-col w-full gap-6 py-6" [ngClass]="isModal ? 'bg-white' : 'bg-background-tertiary min-h-screen'">
  <div class="header-section flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <h3 class="text-2xl font-bold text-brand-tertiary m-0">Agregar muestra</h3>
      <p class="text-sm text-text-secondary m-0">
        Selecciona la forma como quieras ingresar la información de la muestra del paciente.
      </p>
    </div>

    <div class="flex flex-col gap-6">
      <div class="flex flex-row justify-between items-start px-8">
        <div
          (click)="selectIngestionMethod('code')"
          (mouseenter)="hoveredMethod.set('code')"
          (mouseleave)="hoveredMethod.set(null)"
          class="flex flex-col items-center justify-center gap-3 cursor-pointer transition-all"
        >
          <div
            class="rounded-full flex items-center justify-center transition-all"
            [ngClass]="{
              'w-16 h-16': selectedMethod() !== 'code',
              'w-20 h-24': selectedMethod() === 'code',
              'bg-yellow-custom': selectedMethod() !== 'code',
              'bg-yellow-selected': selectedMethod() === 'code'
            }"
          >
            <i class="icon-buscar w-8 h-8"></i>
          </div>
          <p class="text-sm font-semibold text-brand-tertiary m-0">
            Ingresar por código
          </p>
          @if (selectedMethod() === 'code' || hoveredMethod() === 'code') {
            <p class="text-xs text-text-secondary text-center m-0">
              Digitaliza o escanea el<br />código de la muestra
            </p>
          }
        </div>

        <div
          (click)="selectIngestionMethod('id')"
          (mouseenter)="hoveredMethod.set('id')"
          (mouseleave)="hoveredMethod.set(null)"
          class="flex flex-col items-center justify-center gap-3 cursor-pointer transition-all"
        >
          <div
            class="rounded-full flex items-center justify-center transition-all"
            [ngClass]="{
              'w-16 h-16': selectedMethod() !== 'id',
              'w-20 h-24': selectedMethod() === 'id',
              'bg-yellow-custom': selectedMethod() !== 'id',
              'bg-yellow-selected': selectedMethod() === 'id'
            }"
          >
            <i class="icon-carnet w-8 h-8"></i>
          </div>
          <p class="text-sm font-semibold text-brand-tertiary m-0">
            Ingresar ID
          </p>
          @if (selectedMethod() === 'id' || hoveredMethod() === 'id') {
            <p class="text-xs text-text-secondary text-center m-0">
              Digitaliza el tipo y número<br />de documento del paciente
            </p>
          }
        </div>

        <div
          (click)="selectIngestionMethod('manual')"
          class="flex flex-col items-center justify-center gap-3 cursor-pointer transition-all"
        >
          <div
            class="rounded-full flex items-center justify-center transition-all"
            [ngClass]="{
              'w-16 h-16': selectedMethod() !== 'manual',
              'w-20 h-24': selectedMethod() === 'manual',
              'bg-yellow-custom': selectedMethod() !== 'manual',
              'bg-yellow-selected': selectedMethod() === 'manual'
            }"
          >
            <i class="icon-documento w-10 h-10"></i>
          </div>
          <p class="text-sm font-semibold text-brand-tertiary m-0">
            Ingresar manual
          </p>
        </div>

        <div
          (click)="selectIngestionMethod('exam-catalog')"
          (mouseenter)="hoveredMethod.set('exam-catalog')"
          (mouseleave)="hoveredMethod.set(null)"
          class="flex flex-col items-center justify-center gap-3 cursor-pointer transition-all"
        >
          <div
            class="rounded-full flex items-center justify-center transition-all"
            [ngClass]="{
              'w-16 h-16': selectedMethod() !== 'exam-catalog',
              'w-20 h-24': selectedMethod() === 'exam-catalog',
              'bg-yellow-custom': selectedMethod() !== 'exam-catalog',
              'bg-yellow-selected': selectedMethod() === 'exam-catalog'
            }"
          >
            <i class="icon-documento w-10 h-10"></i>
          </div>
          <p class="text-sm font-semibold text-brand-tertiary m-0">
            Gestionar exámenes
          </p>
          @if (selectedMethod() === 'exam-catalog' || hoveredMethod() === 'exam-catalog') {
            <p class="text-xs text-text-secondary text-center m-0">
              Crear y consultar exámenes<br />del catálogo
            </p>
          }
        </div>
      </div>
    </div>

    <div class="w-full border-t border-blue-200"></div>

    <div class="flex flex-col gap-6">
      @if (selectedMethod() === 'exam-catalog') {
        <app-exam-catalog></app-exam-catalog>
      }
      @if (selectedMethod() === 'code') {
        <div class="flex flex-col gap-4">
          <div class="flex gap-4 w-full">
            <div class="flex-1">
              <app-button
                label="Escanea"
                [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
                [size]="ButtonSizeEnum.MD"
                [disabled]="true"
              ></app-button>
            </div>
            <div class="flex-1">
              <app-button
                label="Digitaliza"
                [type]="ButtonTypeEnum.PRIMARY"
                [size]="ButtonSizeEnum.MD"
                (handleClick)="activateCodeSearch()"
              ></app-button>
            </div>
          </div>

          @if (showCodeSearch()) {
            <form [formGroup]="searchForm" class="flex justify-between items-end -ml-2">
              <div class="flex gap-4 flex-1">
                <div class="w-[36rem]">
                  <app-input-text
                    label="Código de la muestra"
                    placeholder="Ingresa el código de la muestra (ej: SPEC0081)"
                    [formControl]="specimenCodeControl"
                  ></app-input-text>
                </div>
              </div>
              <button
                (click)="searchByCode()"
                [disabled]="isSearchByCodeDisabled"
                class="w-16 h-16 min-w-16 mr-8 rounded-full bg-blue-deep hover:bg-blue-800 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center transition-colors shadow-md"
                type="button"
              >
                <i class="icon-buscar w-7 h-7 white"></i>
              </button>
            </form>
          }

          @if (showCodeSearch() && showForm()) {
            <div class="flex items-center gap-2 -mt-2">
              <span
                class="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-deep border border-blue-deep rounded-lg text-sm text-white"
              >
                <span class="font-medium">{{ searchValue() }}</span>
                <button
                  (click)="clearSearch()"
                  class="flex items-center justify-center hover:bg-white/20 rounded transition-colors p-0.5"
                  type="button"
                  aria-label="Limpiar búsqueda"
                >
                  <i class="icon-equis w-3 h-3 white"></i>
                </button>
              </span>
            </div>
          }
        </div>
      }

      @if (selectedMethod() === 'id') {
        <form [formGroup]="searchForm" class="flex justify-between items-end -ml-2">
          <div class="flex gap-4 flex-1">
            <div class="w-64">
              <app-form-dropdown
                label="Seleccione tipo de documento"
                placeholder="Seleccione..."
                [formControl]="searchIdentifierTypeControl"
                [items]="identifierTypeDropdownOptions"
              ></app-form-dropdown>
            </div>
            <div class="w-96">
              <app-input-text
                label="Ingresa número de documento (ID)"
                placeholder="Ingresa número de documento"
                [formControl]="documentNumberControl"
              ></app-input-text>
            </div>
          </div>
          <button
            (click)="searchPatientById()"
            [disabled]="isSearchByIdDisabled"
            class="w-16 h-16 min-w-16 mr-8 rounded-full bg-blue-deep hover:bg-blue-800 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center transition-colors shadow-md"
            type="button"
          >
            <i class="icon-buscar w-7 h-7 white"></i>
          </button>
        </form>

        @if (showForm()) {
          <div class="flex items-center gap-2 -mt-2">
            <span
              class="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-deep border border-blue-deep rounded-lg text-sm text-white"
            >
              <span class="font-medium">{{ searchValue() }}</span>
              <button
                (click)="clearSearch()"
                class="flex items-center justify-center hover:bg-white/20 rounded transition-colors p-0.5"
                type="button"
                aria-label="Limpiar búsqueda"
              >
                <i class="icon-equis w-3 h-3 white"></i>
              </button>
            </span>
          </div>
        }
      }
    </div>

    @if (showForm()) {
      <div class="flex flex-col gap-6">
        <form [formGroup]="sampleForm">
          <div class="bg-white rounded-lg p-6 shadow-sm">
            <h4 class="text-sm font-thin text-gray-700 mb-6">
              Datos personales
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
              <app-input-text
                label="Nombres"
                [formControl]="givenNameControl"
              ></app-input-text>

              <app-input-text
                label="Segundo nombre (Opcional)"
                placeholder="Segundo nombre"
                [formControl]="middleNameControl"
              ></app-input-text>

              <app-input-text
                label="Apellidos"
                [formControl]="familyNameControl"
              ></app-input-text>

              <app-input-text
                label="Apellido materno (Opcional)"
                placeholder="Apellido materno"
                [formControl]="maternalFamilyNameControl"
              ></app-input-text>

              <app-form-dropdown
                label="Tipo de identificación"
                placeholder="Seleccione..."
                [formControl]="identifierTypeControl"
                [items]="identifierTypeDropdownOptions"
              ></app-form-dropdown>

              <app-input-text
                label="Número de documento"
                [formControl]="idNumberControl"
              ></app-input-text>

              <app-form-dropdown
                label="Sexo"
                placeholder="Seleccione..."
                [formControl]="administrativeSexControl"
                [items]="administrativeSexDropdownOptions"
              ></app-form-dropdown>

              <app-form-date
                id="birthDate"
                label="Fecha de nacimiento"
                placeholder="Seleccione fecha"
                [formControl]="birthDateControl"
              ></app-form-date>

              <div class="md:col-span-2">
                <app-input-text
                  label="Correo (Opcional)"
                  placeholder="correo@ejemplo.com"
                  [formControl]="emailAddressControl"
                ></app-input-text>
              </div>

              @if (selectedMethod() === 'manual') {
                <app-input-text
                  label="Estado civil"
                  placeholder="Ej: Soltero, Casado"
                  [formControl]="maritalStatusControl"
                >
                </app-input-text>

                <app-input-text
                  label="Teléfono"
                  placeholder="3001234567"
                  [formControl]="telephoneNumberControl"
                >
                </app-input-text>

                <div class="md:col-span-2">
                  <app-input-text
                    label="Dirección (opcional)"
                    placeholder="Calle 123 #45-67"
                    [formControl]="streetAddressControl"
                  >
                  </app-input-text>
                </div>
              }

              <div class="md:col-span-2">
                <div class="input">
                  <label for="userDataDescription" class="input-label-item">
                    Observación de datos de usuario (opcional)
                  </label>
                  <textarea
                    id="userDataDescription"
                    formControlName="userDataDescription"
                    placeholder="Observación de datos de usuario"
                    rows="2"
                    class="input-head-item resize-none"
                  ></textarea>
                </div>
              </div>

              <div class="md:col-span-2">
                <div class="input">
                  <label for="clinicalHistory" class="input-label-item">
                    Resumen de historia clínica (opcional)
                  </label>
                  <textarea
                    id="clinicalHistory"
                    formControlName="clinicalHistory"
                    placeholder="Resumen de historia clínica"
                    rows="4"
                    class="input-head-item resize-none"
                  ></textarea>
                </div>
              </div>
            </div>

            <h4 class="text-sm font-thin text-gray-700 mb-6 mt-6">
              Datos de la muestra
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
              <app-form-dropdown
                label="Ciudad de ingreso"
                placeholder="Seleccione..."
                [formControl]="regionControl"
                [items]="regionDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Tipo de muestra"
                placeholder="Seleccione..."
                [formControl]="specimenTypeControl"
                [items]="specimenTypeDropdownOptions()"
              ></app-form-dropdown>

              @if (selectedMethod() === 'manual') {
                <app-input-text
                  label="Código de muestra"
                  placeholder="Se generará automáticamente si se deja vacío"
                  [formControl]="specimenIdControl"
                >
                </app-input-text>

                <app-form-dropdown
                  label="Contenedor de muestra"
                  placeholder="Seleccione..."
                  [formControl]="specimenContainerIdControl"
                  [items]="specimenContainerDropdownOptions()"
                ></app-form-dropdown>
              }

              @if (selectedMethod() !== 'manual') {
                <app-form-date
                  id="admissionDate"
                  label="Fecha de ingreso"
                  placeholder="Seleccione fecha"
                  [formControl]="admissionDateControl"
                ></app-form-date>
              }

              <div class="md:col-span-2">
                <div class="input">
                  <label for="descriptionDataSample" class="input-label-item">
                    Observación de datos de muestra (opcional)
                  </label>
                  <textarea
                    id="descriptionDataSample"
                    formControlName="descriptionDataSample"
                    placeholder="Observación de datos de muestra"
                    rows="2"
                    class="input-head-item resize-none"
                  ></textarea>
                </div>
              </div>

              <div class="md:col-span-2">
                <div class="input">
                  <label class="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      formControlName="consentForUseOfSamples"
                      class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                    />
                    <span class="text-sm font-medium text-brand-tertiary">
                      Consentimiento de uso de la información de muestra
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <h4 class="text-sm font-thin text-gray-700 mb-6 mt-6">
              Datos del examen
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
              <app-form-dropdown
                label="Examen solicitado"
                placeholder="Seleccione..."
                [formControl]="examTypeControl"
                [items]="examTypeDropdownOptions()"
              ></app-form-dropdown>

              @if (selectedMethod() !== 'manual') {
                <app-input-text
                  label="Código del examen"
                  placeholder="Código del examen"
                  [formControl]="examCodeControl"
                ></app-input-text>

                <div class="md:col-span-2">
                  <app-input-text
                    label="Grupo de exámenes"
                    placeholder="Grupo de exámenes"
                    [formControl]="examNameControl"
                  ></app-input-text>
                </div>
              }

              <div class="md:col-span-2 mt-4 mb-4">
                <div class="input">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <label class="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        formControlName="acmg"
                        class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                      />
                      <span class="text-sm font-medium text-brand-tertiary">
                        ¿Debe realizar ACMG?
                      </span>
                    </label>

                    <label class="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        formControlName="mlpa"
                        class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                      />
                      <span class="text-sm font-medium text-brand-tertiary">
                        ¿Debe realizar MLPA?
                      </span>
                    </label>

                    <label class="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        formControlName="prioritization"
                        class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                      />
                      <span class="text-sm font-medium text-brand-tertiary">
                        Requiere priorización
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="md:col-span-2">
                <div class="input">
                  <label for="descriptionDataExam" class="input-label-item">
                    Observación de datos del examen (opcional)
                  </label>
                  <textarea
                    id="descriptionDataExam"
                    formControlName="descriptionDataExam"
                    placeholder="Observación de datos del examen"
                    rows="2"
                    class="input-head-item resize-none"
                  ></textarea>
                </div>
              </div>
            </div>

            <h4 class="text-sm font-thin text-gray-700 mb-6 mt-6">
              Datos de la orden
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
              <app-input-text
                label="Código orden"
                placeholder="Código orden"
                [formControl]="placerOrderNumberControl"
              ></app-input-text>

              @if (selectedMethod() === 'manual') {
                <app-input-text
                  label="Número de caso"
                  placeholder="Ej: CASE-2025"
                  [formControl]="caseNumberInputControl"
                ></app-input-text>
              }

              <app-form-dropdown
                label="Sede toma de muestra"
                placeholder="Seleccione..."
                [formControl]="siteControl"
                [items]="siteDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Prioridad"
                placeholder="Seleccione..."
                [formControl]="priorityIdControl"
                [items]="priorityDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Laboratorio de referencia"
                placeholder="Seleccione..."
                [formControl]="laboratoriesIdControl"
                [items]="laboratoriesDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Diagnóstico"
                placeholder="Seleccione..."
                [formControl]="diagnosesIdControl"
                [items]="diagnosesDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Especialista (opcional)"
                placeholder="Seleccione..."
                [formControl]="specialistsIdControl"
                [items]="specialistsDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Proveedor"
                placeholder="Seleccione..."
                [formControl]="providerIdControl"
                [items]="providerDropdownOptions()"
              ></app-form-dropdown>

              <app-form-dropdown
                label="Compañía aseguradora"
                placeholder="Seleccione..."
                [formControl]="companyIdControl"
                [items]="insuranceCompanyDropdownOptions()"
              ></app-form-dropdown>
            </div>

            <h4 class="text-sm font-thin text-gray-700 mb-6 mt-6">
              Datos de reproceso
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
              <div class="md:col-span-2 mb-4">
                <div class="input">
                  <label class="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      formControlName="isReprocess"
                      class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                    />
                    <span class="text-sm font-medium text-brand-tertiary">
                      ¿Es reproceso?
                    </span>
                  </label>
                </div>
              </div>

              @if (isReprocessChecked()) {
                <app-form-dropdown
                  label="Causa de reproceso"
                  placeholder="Seleccione..."
                  [formControl]="causeReprocessIdControl"
                  [items]="causeReprocessDropdownOptions()"
                ></app-form-dropdown>

                <app-form-dropdown
                  label="Estado de reproceso"
                  placeholder="Seleccione..."
                  [formControl]="statusReprocessIdControl"
                  [items]="statusReprocessDropdownOptions()"
                ></app-form-dropdown>

                <div class="md:col-span-2">
                  <div class="input">
                    <label for="reprocessDescription" class="input-label-item">
                      Observación del reproceso
                    </label>
                    <textarea
                      id="reprocessDescription"
                      formControlName="reprocessDescription"
                      placeholder="Observación del reproceso"
                      rows="3"
                      class="input-head-item resize-none"
                    ></textarea>
                  </div>
                </div>
              }
            </div>

            <div
              class="flex justify-between gap-4 mt-8 pt-6 border-t border-gray-200"
            >
              <button
                type="button"
                (click)="cancelSample()"
                class="px-6 py-3 border-2 border-blue-deep text-blue-deep rounded-lg hover:bg-blue-50 transition-colors font-medium"
              >
                Cancelar
              </button>
              @if (selectedMethod() === 'manual') {
                <button
                  type="button"
                  (click)="saveManualSample()"
                  [disabled]="sampleForm.invalid"
                  class="px-6 py-3 bg-blue-deep text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
                >
                  Guardar muestra
                </button>
              } @else {
                <button
                  type="button"
                  (click)="saveSample()"
                  [disabled]="sampleForm.invalid"
                  class="px-6 py-3 bg-blue-deep text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
                >
                  Guardar muestra
                </button>
              }
            </div>
          </div>
        </form>
      </div>
    }
  </div>
</div>

<app-add-sample-manual
  #manualEntryModal
  [familyMemberMode]="true"
  (familyMemberSaved)="onFamilyMemberAdded($event)"
></app-add-sample-manual>

<app-family-members-modal
  #familyMembersModal
  [lgBase]="savedLgNumber()"
  [examType]="savedExamType() || 'TRIO'"
  [orderId]="savedOrderId()"
  [placerOrderNumber]="savedPlacerOrderNumber()"
  [affecteeOrderData]="affecteeOrderData"
  [examTypeId]="savedExamTypeId()"
  [identifierTypes]="identifierTypeDropdownOptions"
  [specimenTypes]="specimenTypeDropdownOptions()"
  [specimenContainers]="specimenContainerDropdownOptions()"
  [priorities]="priorityDropdownOptions()"
  [companies]="insuranceCompanyDropdownOptions()"
  [providers]="providerDropdownOptions()"
  [regions]="regionDropdownOptions()"
  [sites]="siteDropdownOptions()"
  [laboratories]="laboratoriesDropdownOptions()"
  [diagnoses]="diagnosesDropdownOptions()"
  [specialists]="specialistsDropdownOptions()"
  [examTypes]="examTypeDropdownOptions()"
  [causeReprocessOptions]="causeReprocessDropdownOptions()"
  [statusReprocessOptions]="statusReprocessDropdownOptions()"
  (saved)="onFamilyMembersSaved($event)"
  (closed)="onFamilyModalClosed()"
></app-family-members-modal>
